export default __webpack_public_path__ + "static/media/Damaso_No17Closed.e504caf4.jpg";